import { render, staticRenderFns } from "./defaultView.vue?vue&type=template&id=0e48964d&scoped=true&"
import script from "./defaultView.vue?vue&type=script&lang=js&"
export * from "./defaultView.vue?vue&type=script&lang=js&"
import style0 from "./defaultView.vue?vue&type=style&index=0&id=0e48964d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e48964d",
  null
  
)

export default component.exports